import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * cart-create operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const createCart = async ({
  request,
}: {
  request: ApiTypes["cart-create"]["request"];
}): Promise<ApiTypes["cart-create"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["cart-create"]["response"]
    >(`/api/public/v2025-06/commerce/carts`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to createCart");
    throw error;
  }
};

/**
 * cart-get operation
 * @param params - Contains path parameters
 * @param query - Contains query parameters
 * @returns Promise resolving to the API response
 */
export const getCart = async ({
  params,
  query,
}: {
  params: ApiTypes["cart-get"]["parameters"]["path"];
  query?: ApiTypes["cart-get"]["parameters"]["query"];
}): Promise<ApiTypes["cart-get"]["response"]> => {
  try {
    const response = await axiosInstance.get<ApiTypes["cart-get"]["response"]>(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}`,
      { params: query },
    );
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to getCart: ${params.cart_token}");
    throw error;
  }
};

/**
 * cart-update operation
 * @param params - Contains path parameters
 * @param query - Contains query parameters
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const updateCart = async ({
  params,
  query,
  request,
}: {
  params: ApiTypes["cart-update"]["parameters"]["path"];
  query?: ApiTypes["cart-update"]["parameters"]["query"];
  request: ApiTypes["cart-update"]["request"];
}): Promise<ApiTypes["cart-update"]["response"]> => {
  try {
    const response = await axiosInstance.patch<
      ApiTypes["cart-update"]["response"]
    >(`/api/public/v2025-06/commerce/carts/${params.cart_token}`, request, {
      params: query,
    });
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to updateCart: ${params.cart_token}",
    );
    throw error;
  }
};
